import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './screens/Home/Home';
import { About } from './screens/About/About';
import { ContactUs } from './screens/ContactUs/ContactUs';
import { Services } from './screens/Services/Services';
import { WhatsAppButton } from './components/WhatsAppButton';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
